<template>
  <aside class="lesson-lessons-list text-light mt-5 mt-lg-0">
    <div class="my-n3">
      <div
        v-for="(lesson, i) in lessons"
        :key="i"
        class="media text-decoration-none text-light align-items-center"
        :id="`lesson-${lesson.id}`"
      >
        <router-link :to="{ name: 'lesson', params: { lesson: lesson.id } }">
          <img :src="picture(lesson)" />
        </router-link>

        <div class="media-body d-flex align-items-center pl-3">
          <small class="flex-fill pr-2 font-weight-bold">
            <router-link
              :to="{ name: 'lesson', params: { lesson: lesson.id } }"
              class=" text-decoration-none text-light  align-items-center"
            >
              <div class="lesson-name">{{ lesson.name }}</div>
              <small class="lesson-details"
                >{{ i + 1 }} / {{ lessons.length }}</small
              >
              <small class="mx-2"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="6"
                  height="6"
                  viewBox="0 0 6 6"
                  fill="none"
                >
                  <path
                    d="M4.23054 0.666626H2.14066C1.27478 0.666626 0.573242 1.33799 0.573242 2.16663V4.16662C0.573242 4.99525 1.27478 5.66662 2.14066 5.66662H4.23054C5.09641 5.66662 5.79795 4.99525 5.79795 4.16662V2.16663C5.79795 1.33797 5.09644 0.666626 4.23054 0.666626Z"
                    fill="#9A9A9A"
                  /></svg
              ></small>
              <small class="lesson-details">{{ lesson.duration }}</small>
            </router-link>
          </small>
          <b-spinner
            class="spinner"
            v-if="loadingFinish === i"
            small
            variant="success"
            :id="i"
          />

          <button
            v-if="lesson.progress && lesson.progress.finished_at"
            class="circle check"
            @click="toggleFinished(i)"
          >
            <img src="https://img.icons8.com/metro/16/FFFFFF/checkmark.png" />
          </button>
          <button v-else class="circle" @click="toggleFinished(i)" />
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      searchTerm: "",
      loadingFinish: false
    };
  },
  computed: {
    lessons() {
      return this.course.lessons.filter(
        item =>
          item.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) >= 0
      );
    }
  },
  methods: {
    picture(lesson) {
      return lesson.picture || this.course.cover;
    },
    duration(lesson) {
      if (!lesson.duration) return "";
      let [h, m, s] = lesson.duration.split(":");
      if (h === "00") {
        return `${m}:${s}`;
      } else {
        return lesson.duration;
      }
    },
    finishedLesson(position) {
      return (
        this.lessons[position] &&
        this.lessons[position].progress &&
        this.lessons[position].progress.finished_at
      );
    },
    toggleFinished(position) {
      this.saveProgress(
        { finished: !this.finishedLesson(position), duration: 0 },
        true,
        position
      );
    },
    saveProgress({ finished, duration }, refresh = false, position) {
      if (refresh) {
        this.loadingFinish = position;
      }
      this.$store
        .dispatch("courses/setProgress", {
          lesson: this.lessons[position].id,
          stopped_at: parseInt(duration),
          finished_at: finished
        })
        .then(() => {
          if (refresh) {
            this.$store
              .dispatch("courses/getDetails", this.$route.params.id)
              .finally(() => {
                this.loadingFinish = false;
              });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson-lessons-list {
  padding-top: 9px;
  a:hover {
    background: rgba(100, 100, 100, 0.05);
  }

  .circle {
    background-color: transparent;
    min-width: 20px;
    min-height: 20px;
    max-width: 20px;
    max-height: 20px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(255, 255, 255, 0.3);

    img {
      width: 16px;
      height: 16px;
    }

    &.check {
      background: #04c56b;
      border-color: #04c56b;
    }
  }

  .media {
    padding: 8px;
    img {
      max-width: 160px;
    }
  }

  .lesson-name {
    font-size: 12px;
    font-weight: 700;
  }

  .lesson-details {
    font-size: 12px;
    color: #9a9a9a;
  }

  .badge {
    font-size: 14px;
    font-weight: bold;
    background: rgba(255, 255, 255, 0.2);
    color: white;
  }

  .spinner {
    position: absolute;
    right: 50px;
  }
}
</style>
